import React, {useState, useEffect} from "react"

import FormattedMessage from "@irati/utils/lang"
import {Body} from "@irati/ui/src/Typography"
import GenericModal from "@irati/ui/src/GenericModal"
import Button from "@irati/ui/src/Button"

interface Props {
  show: boolean
  onHide: () => void
  onDelete: () => void
}

const ConfirmDeletePhoneNo: React.FC<Props> = ({show, onHide, onDelete}) => {
  const [showModal, setShowModal] = useState<boolean>(show)

  useEffect(() => {
    setShowModal(show)
  }, [show])

  return (
    <GenericModal customWidth={550} hideActions show={showModal} onHide={onHide}>
      <Body marginTop={2} marginBottom={3} textAlign="center" weight="bold" maxWidth="100%">
        <FormattedMessage id="account.profile.deletePhoneNo.title" />
      </Body>
      <Body marginBottom={3} textAlign="center" maxWidth="100%">
        <FormattedMessage id="account.profile.deletePhoneNo.subTitle" />
      </Body>
      <Button mobileFull full primary onClick={onDelete}>
        <FormattedMessage id="account.profile.deletePhoneNo.deleteBtn" />
      </Button>
    </GenericModal>
  )
}

export default ConfirmDeletePhoneNo
